{
  "version": 1,
  "asset_id": "76c102e0-77af-475d-a016-2be2dc7c702c",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/76c102e0-77af-475d-a016-2be2dc7c702c/hero-money.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/76c102e0-77af-475d-a016-2be2dc7c702c/hero-money.jpg",
  "original_filename": "hero-money.jpg",
  "size": 169694,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:04Z"
}
